import { OptionInterface } from "projects/shared/src/lib/core/interfaces";

export const DailyRecurrence = 'DailyRecurrence';
export const WeeklyRecurrence = 'WeeklyRecurrence';
export const ScheduleType: OptionInterface[] = [
  { label: 'Due date', value: 'dueDate' },
  { label: 'Recurrence', value: 'recurrence' },
];

export const Frequency: OptionInterface[] = [
  { label: 'Daily', value: 'DailyRecurrence' },
  { label: 'Weekly', value: 'WeeklyRecurrence' },
  { label: 'Monthly', value: 'MonthlyRecurrence' },
  { label: 'Annualy', value: 'YearlyRecurrence' },
];
export const Weekdays: OptionInterface[] = [
  { label: 'S', value: 'Sunday' },
  { label: 'M', value: 'Monday' },
  { label: 'T', value: 'Tuesday' },
  { label: 'W', value: 'Wednesday' },
  { label: 'T', value: 'Thursday' },
  { label: 'F', value: 'Friday' },
  { label: 'S', value: 'Saturday' },
];

export const TimeFormats: OptionInterface[] = [
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' },
];

export const TimeZones: OptionInterface[] = [
  { label: 'Eastern Standard Time', value: 'Eastern Standard Time' },
  { label: 'Central Standard Time', value: 'Central Standard Time' },
  { label: 'Mountain Standard Time', value: 'Mountain Standard Time' },
  { label: 'Pacific Standard Time', value: 'Pacific Standard Time' },
  { label: 'Metlakatla Standard Time', value: 'Metlakatla Standard Time' },
  { label: 'Alaska Standard Time', value: 'Alaska Standard Time' },
  { label: 'Hawaii Standard Time', value: 'Hawaii Standard Time' },
  { label: 'Western European Time', value: 'Western European Time' },
  { label: 'Israel Standard Time', value: 'Israel Standard Time' },
  { label: 'Central African Time', value: 'Central African Time' },
  { label: 'Eastern European Time', value: 'Eastern European Time' },
  { label: 'Arabia Standard Time', value: 'Arabia Standard Time' },
  { label: 'Eastern African Time', value: 'Eastern African Time' },
  { label: 'Moscow Standard Time', value: 'Moscow Standard Time' },
  { label: 'India Standard Time', value: 'India Standard Time' },
  { label: 'Hong Kong Time', value: 'Hong Kong Time' },
  { label: 'East Indonesia Time', value: 'East Indonesia Time' },
];
